export default class Fournisseur {
  name: string = "";
  id: string = "";
}
